import { HStack, Text } from '@montel/montelpro-shared-components-v2';

interface AuditLogEventTypeMapping {
	message: string;
	name: string;
	DetailsCellComponent?: React.ComponentType<{
		data: any;
		onClick?: (data?: any) => void;
	}>;
}

export const getEventTypeMapping = (type: string): AuditLogEventTypeMapping => {
	switch (type) {
		case 'AccountCreated':
			return {
				message: 'Account created',
				name: 'Account Created',
			};
		case 'AccountEmailVerified':
			return {
				message: 'Account email verified',
				name: 'Account Email Verified',
			};
		case 'AccountEmailChanged':
			return {
				message: 'Account email changed',
				name: 'Account Email Changed',
			};
		case 'AccountLocked':
			return {
				message: 'Account locked',
				name: 'Account Locked',
			};
		case 'AccountUnlocked':
			return {
				message: 'Account unlocked',
				name: 'Account Unlocked',
			};
		case 'AccountVerificationEmailResent':
			return {
				message: 'Account verification email resent',
				name: 'Account Verification Email Resent',
			};
		case 'AccountMarkedReviewed':
			return {
				message: 'Account marked as reviewed',
				name: 'Account Marked Reviewed',
			};
		case 'UserInvited':
			return {
				message: 'User invited',
				name: 'User Invited',
			};
		case 'ApplicationRegistrationCreated':
			return {
				message: 'Application registration created',
				name: 'Application Registration Created',
			};
		case 'ApplicationAccessGranted':
			return {
				message: 'Application access granted',
				name: 'Application Access Granted',
			};
		case 'ApplicationAccessRevoked':
			return {
				message: 'Application access revoked',
				name: 'Application Access Revoked',
			};
		case 'SubscriptionSeatAssigned':
			return {
				message: 'Subscription seat assigned',
				name: 'Subscription Seat Assigned',
			};
		case 'SubscriptionSeatUnassigned':
			return {
				message: 'Subscription seat unassigned',
				name: 'Subscription Seat Unassigned',
			};
		case 'SubscriptionCreated':
			return {
				message: 'Subscription created',
				name: 'Subscription Created',
			};
		case 'SubscriptionCancelled':
			return {
				message: 'Subscription cancelled',
				name: 'Subscription Cancelled',
			};
		case 'SubscriptionUpdated':
			return {
				message: 'Subscription updated',
				name: 'Subscription Updated',
				DetailsCellComponent: ({ data, onClick }) => (
					<HStack gap="sm" onClick={() => onClick && onClick(data)}>
						<Text fontStyle="italic">Click to see changes</Text>
					</HStack>
				),
			};
		case 'SubscriptionOrdered':
			return {
				message: 'Subscription ordered',
				name: 'Subscription Ordered',
			};
		case 'SubscriptionActivated':
			return {
				message: 'Subscription activated',
				name: 'Subscription Activated',
			};
		case 'SubscriptionReactivated':
			return {
				message: 'Subscription reactivated',
				name: 'Subscription Reactivated',
			};
		case 'SubscriptionReallocated':
			return {
				message: 'Subscription reallocated',
				name: 'Subscription Reallocated',
			};
		case 'SubscriptionDeleted':
			return {
				message: 'Subscription deleted',
				name: 'Subscription Deleted',
			};
		case 'SubscriptionBundleCreated':
			return {
				message: 'Subscription bundle created',
				name: 'Subscription Bundle Created',
			};
		case 'SubscriptionBundleUpdated':
			return {
				message: 'Subscription bundle updated',
				name: 'Subscription Bundle Updated',
			};
		case 'SubscriptionBundleDeleted':
			return {
				message: 'Subscription bundle deleted',
				name: 'Subscription Bundle Deleted',
			};
		case 'SubscriptionBundleCancelled':
			return {
				message: 'Subscription bundle cancelled',
				name: 'Subscription Bundle Cancelled',
			};
		case 'SubscriptionBundleSubscriptionAdded':
			return {
				message: 'Subscription added to bundle',
				name: 'Subscription Bundle Subscription Added',
			};
		case 'SubscriptionBundleSubscriptionRemoved':
			return {
				message: 'Subscription removed from bundle',
				name: 'Subscription Bundle Subscription Removed',
			};
		case 'CompanyCreated':
			return {
				message: 'Company created',
				name: 'Company Created',
			};
		case 'CompanyUpdated':
			return {
				message: 'Company updated',
				name: 'Company Updated',
			};
		case 'AccountAssignedToCompany':
			return {
				message: 'Account assigned to company',
				name: 'Account Assigned to Company',
			};
		case 'CompanyDeleted':
			return {
				message: 'Company deleted',
				name: 'Company Deleted',
			};
		case 'AdminAccountDeleted':
			return {
				message: 'Admin account deleted',
				name: 'Admin Deleted',
				DetailsCellComponent: ({ data }) => (
					<HStack gap="sm">
						<Text fontStyle="italic">Email:</Text>
						<Text>{`${data?.email}`}</Text>
					</HStack>
				),
			};
		default:
			return {
				message: 'Unknown event',
				name: 'Unknown Event',
			};
	}
};
